/* eslint-disable eqeqeq */
import Vue from 'vue'
import Vant from 'vant'

import './plugins/axios'
import App from './App.vue'

// 先关闭PWA设置
// import './registerServiceWorker'
import router from './router'
import store from './store'

import NProgress from 'nprogress'
import 'vant/lib/index.less'

import './app.less'

Vue.config.productionTip = false

Vue.use(Vant)

NProgress.configure({
  showSpinner: false
})

router.beforeEach((to, from, next) => {
  NProgress.start()

  // 设置标题
  if (to.meta && to.meta.title) {
    document.title = to.meta.title
  }
  next()
})

// 页面打开以后
router.afterEach((to, from) => {
  NProgress.done()
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
